"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordList = void 0;
var tslib_1 = require("tslib");
var fetch_1 = require("../../../library/fetch");
var nucalm_1 = require("../../model/nucalm");
var service_1 = require("../../../library/base/service");
var RecordList = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(RecordList, _super);
    function RecordList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = '预约历史记录';
        _this.code = '101204';
        _this.desc = '预约历史记录';
        _this.requestParams = new nucalm_1.NucalmRequest();
        _this.method = fetch_1.Methods.GET;
        return _this;
    }
    return RecordList;
}(service_1.BaseService));
exports.RecordList = RecordList;
//# sourceMappingURL=recordList.js.map